const MAX_DISPLAYED_COUNT = 99;

export const formatBadgeCount = (count: number): string =>
   count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : `${count}`;
